<nz-header class="table-header">
  <div class="table-header-row margin-lr">
    <div class="table-header-cell">
      {{ "Geriatric Depression Scale" | translate }}
    </div>
  </div>
</nz-header>

@if (!isLoading) {
  <form
    style="margin-bottom: 10em"
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
  >
    <app-speech-gds-therapy-questions
      [elements]="pages[current].elements"
      [formGroup]="formGroup"
      [readonlyMode]="readonlyMode"
    ></app-speech-gds-therapy-questions>

    <div class="notes">
      <ul>
        <li>{{ "GDS_NoDepression" | translate }}</li>
        <li>{{ "GDS_ModerateDepression" | translate }}</li>
        <li>{{ "GDS_SevereDepression" | translate }}</li>
      </ul>
      <hr />
      <p>
        {{ "GDS_ScoringRule" | translate }}
      </p>
      <p>{{ "GDS_ReverseScoring" | translate }}</p>
      <p>{{ "GDS_StandardScoring" | translate }}</p>
    </div>
    <div class="steps-action">
      <div class="right-actions" *hasAddPermissions="['a-sqa']">
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzDanger
            class="cancel-btn"
            type="button"
            (click)="revertForm()"
            [disabled]="!hasChanges"
          >
            <span>{{ "Revert" | translate }}</span>
          </button>
        }
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzType="primary"
            type="submit"
            [disabled]="!hasChanges"
          >
            <span>{{ "Submit" | translate }}</span>
          </button>
        }
      </div>
    </div>
  </form>
}

@if (isLoading) {
  <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
}
